import type { MeDto } from "../../types/index.ts";
import { formatSek } from "../message/utils.ts";
import styles from "./usage-meter.module.css";

/**
 * How much of this month's ceiling the person has used, red past 80 % before a turn is refused, and
 * beside it everything they have spent since they started, in kronor.
 */
export function UsageMeter({ me, className }: { me: MeDto; className?: string }) {
  const share = Math.min(1, me.monthCostUsd / me.monthlyLimitUsd);
  return (
    <div
      className={`${styles.usage} ${className ?? ""}`}
      title="Uppskattad kostnad den här månaden, av din månadsgräns. Nollställs den första varje månad."
    >
      <span>Månadens användning</span>
      <span className={styles.meter}>
        <span className={styles.fill} style={{ width: `${Math.max(share * 100, 2)}%` }} data-high={share > 0.8} />
      </span>
      <span className={styles.value}>
        {formatSek(me.monthCostUsd, me.sekPerUsd)} av {formatSek(me.monthlyLimitUsd, me.sekPerUsd)}
      </span>
      <span className={styles.total} title="Uppskattad kostnad för allt du gjort i Sortera Factory hittills.">
        Totalt <span className={styles.value}>{formatSek(me.totalCostUsd, me.sekPerUsd)}</span>
      </span>
    </div>
  );
}
